<p-calendar
  [locale]="locale"
  [id]="id || name"
  [disabled]="disabled"
  [ngClass]="customClass"
  [class.invalid]="invalid"
  [dateFormat]="dateFormat"
  [placeholder]="placeholder"
  [yearNavigator]="true"
  [yearRange]="yearRange"
  [showIcon]="true"
  [showButtonBar]="showButtonBar"
  [view]="view"
  [maxDate]="maxDate"
  [minDate]="minDate"
  (onClearClick)="change()"
  (onSelect)="change()"
  (onBlur)="blur()"
  [(ngModel)]="rangeDates"
  selectionMode="range"
  [readonlyInput]="true"
>
</p-calendar>
